import React from 'react'
import loadingImg from "./../../assets/images/loading-spinner.gif"

const Loading = () => {
    return (
        <div className="loadingContainer">
            <img src={loadingImg} className="loadingImg" alt="loading-img" />
        </div>
    )
}

export default Loading